import React from 'react';
import * as Icon from 'react-feather';
import { contact, talkLink } from './cartoon/links';

const canais = [
    { icon: <Icon.MessageCircle size={22} />, nome: 'WhatsApp', valor: contact.phone, href: talkLink },
    { icon: <Icon.Mail size={22} />, nome: 'E-mail', valor: contact.email, href: contact.emailHref },
    { icon: <Icon.Instagram size={22} />, nome: 'Instagram', valor: contact.instagram, href: contact.instagramUrl },
    { icon: <Icon.Clock size={22} />, nome: 'Atendimento', valor: contact.hours },
    { icon: <Icon.Home size={22} />, nome: 'Sede', valor: contact.city },
];

export default function Contact() {
    return (
        <section className="lc lc-section bg-violeta" id="contato">
            <div className="lc-wrap lc-grid-2">
                <div>
                    <span className="lc-pill">fale com a gente</span>
                    <h2 className="lc-title">Ficou com alguma dúvida<span className="lc-dot">?</span></h2>
                    <p className="lc-text">
                        Pode perguntar à vontade: sobre o café, o preparo ou o seu pedido. A gente responde
                        rapidinho em horário comercial.
                    </p>
                    <div className="lc-actions">
                        <a href={talkLink} target="_blank" rel="noopener noreferrer" className="lc-btn">
                            <Icon.MessageCircle size={22} aria-hidden="true" /> Chamar no WhatsApp
                        </a>
                    </div>
                </div>
                <div className="lc-card">
                    <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 18 }}>
                        {canais.map((c) => (
                            <li key={c.nome} style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                                <span aria-hidden="true" style={{ flex: '0 0 48px', height: 48, borderRadius: '50%', background: 'var(--lc-verm)', color: '#fff', border: '3px solid #000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {c.icon}
                                </span>
                                <div>
                                    <div style={{ fontSize: 14, fontWeight: 500, color: '#555' }}>{c.nome}</div>
                                    {c.href ? (
                                        <a href={c.href} target={c.href.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer" style={{ fontSize: 19, fontWeight: 700, color: '#000' }}>
                                            {c.valor}
                                        </a>
                                    ) : (
                                        <div style={{ fontSize: 19, fontWeight: 700 }}>{c.valor}</div>
                                    )}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
